import React, { useEffect, useState } from 'react';
import { partnersAPI } from '../../services/api';
import toast from 'react-hot-toast';

const TABS = [
  { id: 'whatsapp',  label: 'WhatsApp',     icon: '💬' },
  { id: 'email',     label: 'Email',        icon: '📧' },
  { id: 'qr',        label: 'QR Code',      icon: '📷' },
  { id: 'roi',       label: 'ROI Card',     icon: '📈' },
  { id: 'loom',      label: 'Loom Script',  icon: '🎬' },
];

function CopyButton({ text, label = 'Copy' }) {
  const [copied, setCopied] = useState(false);
  const handle = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <button onClick={handle}
      style={{
        padding: '7px 14px', border: '1.5px solid', borderRadius: 8,
        fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s',
        background: copied ? '#dcfce7' : '#f8fafc',
        color: copied ? '#15803d' : '#475569',
        borderColor: copied ? '#86efac' : '#e2e8f0',
      }}>
      {copied ? '✓ Copied!' : `📋 ${label}`}
    </button>
  );
}

export default function OutreachKitModal({ onClose, onAddStudent }) {
  const [kit, setKit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('whatsapp');
  const [whatsappMode, setWhatsappMode] = useState('broadcast');

  useEffect(() => {
    partnersAPI.getOutreachKit()
      .then(r => setKit(r.data?.data))
      .catch(() => toast.error('Failed to load outreach kit'))
      .finally(() => setLoading(false));
  }, []);

  const roi = kit?.student_roi_calculator_data;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: 18, width: '100%', maxWidth: 680, maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 80px rgba(0,0,0,0.2)' }}>
        {/* Modal Header */}
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: 17, fontWeight: 800, color: '#1B2A6B', margin: 0 }}>📤 Outreach Kit</h2>
            <p style={{ fontSize: 12, color: '#64748b', margin: '2px 0 0' }}>Share registration links and templates with students</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {onAddStudent && (
              <button onClick={onAddStudent}
                style={{ border: 'none', background: '#1B2A6B', borderRadius: 8, padding: '7px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 700, color: '#C9A84C', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
                + Add Student Enquiry
              </button>
            )}
            <button onClick={onClose}
              style={{ border: 'none', background: '#f1f5f9', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', fontSize: 18, color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              ×
            </button>
          </div>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
            <div style={{ width: 36, height: 36, border: '3px solid #C9A84C', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        ) : kit ? (
          <>
            {/* Registration Link Bar */}
            <div style={{ padding: '12px 22px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#64748b' }}>🔗 Your Link:</span>
                <code style={{ fontSize: 12, color: '#1B2A6B', background: '#e0e7ff', padding: '3px 8px', borderRadius: 6, flex: 1, wordBreak: 'break-all' }}>
                  {kit.registration_url}
                </code>
                <CopyButton text={kit.registration_url} label="Copy Link" />
              </div>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', overflowX: 'auto', padding: '0 22px' }}>
              {TABS.map(t => (
                <button key={t.id} onClick={() => setActiveTab(t.id)}
                  style={{
                    padding: '10px 14px', border: 'none', background: 'none', cursor: 'pointer',
                    fontSize: 13, fontWeight: activeTab === t.id ? 700 : 500,
                    color: activeTab === t.id ? '#1B2A6B' : '#64748b',
                    borderBottom: `2px solid ${activeTab === t.id ? '#C9A84C' : 'transparent'}`,
                    marginBottom: -1, whiteSpace: 'nowrap', fontFamily: 'inherit',
                  }}>
                  {t.icon} {t.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '18px 22px' }}>
              {/* WhatsApp Tab */}
              {activeTab === 'whatsapp' && (
                <div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
                    {[['broadcast', '📢 Broadcast'], ['personal', '👤 Personal']].map(([mode, label]) => (
                      <button key={mode} onClick={() => setWhatsappMode(mode)}
                        style={{
                          padding: '6px 14px', borderRadius: 20, border: '1.5px solid',
                          fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
                          background: whatsappMode === mode ? '#25D366' : '#fff',
                          color: whatsappMode === mode ? '#fff' : '#64748b',
                          borderColor: whatsappMode === mode ? '#25D366' : '#e2e8f0',
                        }}>
                        {label}
                      </button>
                    ))}
                  </div>

                  {whatsappMode === 'broadcast' ? (
                    <>
                      <p style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>Send this to WhatsApp groups or broadcast lists:</p>
                      <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '14px 16px', whiteSpace: 'pre-wrap', fontSize: 13, color: '#1e293b', lineHeight: 1.6, fontFamily: 'monospace' }}>
                        {kit.whatsapp_broadcast}
                      </div>
                      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                        <CopyButton text={kit.whatsapp_broadcast} label="Copy Message" />
                        <a href={`https://wa.me/?text=${encodeURIComponent(kit.whatsapp_broadcast)}`} target="_blank" rel="noopener noreferrer"
                          style={{ padding: '7px 14px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, textDecoration: 'none', cursor: 'pointer' }}>
                          💬 Open in WhatsApp
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <p style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>Send this personally to individual students. Replace [Student Name] before sending:</p>
                      <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '14px 16px', whiteSpace: 'pre-wrap', fontSize: 13, color: '#1e293b', lineHeight: 1.6, fontFamily: 'monospace' }}>
                        {kit.whatsapp_personal}
                      </div>
                      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                        <CopyButton text={kit.whatsapp_personal} label="Copy Message" />
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Email Tab */}
              {activeTab === 'email' && (
                <div>
                  <p style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>Replace [Student Name] before sending. Works for Gmail, Outlook, etc.:</p>
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px', whiteSpace: 'pre-wrap', fontSize: 13, color: '#1e293b', lineHeight: 1.7, fontFamily: 'monospace' }}>
                    {kit.email_template}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                    <CopyButton text={kit.email_template} label="Copy Email" />
                  </div>

                  <div style={{ marginTop: 16 }}>
                    <p style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 6 }}>SMS TEMPLATE</p>
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#1e293b', fontFamily: 'monospace' }}>
                      {kit.sms_template}
                    </div>
                    <div style={{ marginTop: 6 }}>
                      <CopyButton text={kit.sms_template} label="Copy SMS" />
                    </div>
                  </div>
                </div>
              )}

              {/* QR Code Tab */}
              {activeTab === 'qr' && (
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
                    Print this QR code and display it at your college. Students can scan to register instantly.
                  </p>
                  <div style={{ display: 'inline-block', padding: 16, background: '#fff', border: '2px solid #e2e8f0', borderRadius: 16 }}>
                    <img src={kit.qr_code_base64} alt="Registration QR Code" style={{ width: 240, height: 240, display: 'block' }} />
                  </div>
                  <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 8 }}>Scan to register at Nova Era Labs</p>
                  <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'center' }}>
                    <a href={kit.qr_code_base64} download="novaeralabs-registration-qr.png"
                      style={{ padding: '8px 16px', background: '#1B2A6B', color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none', cursor: 'pointer' }}>
                      ⬇ Download QR Code
                    </a>
                    <CopyButton text={kit.registration_url} label="Copy Link" />
                  </div>

                  <div style={{ marginTop: 20, padding: '14px 16px', background: '#f8fafc', borderRadius: 10, textAlign: 'left' }}>
                    <p style={{ fontSize: 12, fontWeight: 700, color: '#64748b', margin: '0 0 8px' }}>💡 USAGE IDEAS</p>
                    <ul style={{ margin: 0, padding: '0 0 0 16px', fontSize: 13, color: '#64748b', lineHeight: 1.8 }}>
                      <li>Print on A4 and paste on college notice boards</li>
                      <li>Include in presentation slides during seminars</li>
                      <li>Add to WhatsApp status / stories</li>
                      <li>Print on visiting cards</li>
                    </ul>
                  </div>
                </div>
              )}

              {/* ROI Card Tab */}
              {activeTab === 'roi' && roi && (
                <div>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
                    Share this ROI card with students to show the value of the program:
                  </p>
                  <div style={{ background: 'linear-gradient(135deg, #1B2A6B, #2d3f8a)', borderRadius: 16, padding: '22px 24px', color: '#fff' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
                      <div>
                        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', fontWeight: 700, letterSpacing: 1 }}>NOVA ERA LABS</div>
                        <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2 }}>Student ROI Card</div>
                      </div>
                      <div style={{ fontSize: 32 }}>⚡</div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 18 }}>
                      <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px' }}>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>AVG SALARY WITHOUT</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: '#fca5a5', marginTop: 4 }}>₹{roi.avg_salary_without_program} LPA</div>
                      </div>
                      <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px' }}>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>AVG SALARY WITH</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: '#86efac', marginTop: 4 }}>₹{roi.avg_salary_with_program} LPA</div>
                      </div>
                      <div style={{ background: 'rgba(201,168,76,0.3)', borderRadius: 10, padding: '12px' }}>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>SALARY UPLIFT</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: '#C9A84C', marginTop: 4 }}>
                          +₹{roi.avg_salary_with_program - roi.avg_salary_without_program} LPA
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 13 }}>
                      <span>✅ {roi.placement_rate_percent}% Placement Rate</span>
                      <span>⏱ {roi.program_duration_months} Month Program</span>
                      <span>🎓 {roi.scholarship_coverage_percent}% Scholarship Available</span>
                    </div>

                    <div style={{ marginTop: 14, fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>
                      Hiring: {roi.companies_hiring.join(' · ')}
                    </div>
                  </div>

                  <div style={{ marginTop: 12 }}>
                    <p style={{ fontSize: 11, color: '#64748b', margin: '0 0 8px' }}>ROI SUMMARY TEXT TO SHARE:</p>
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px', fontSize: 13, color: '#1e293b', fontFamily: 'monospace' }}>
                      {`🚀 Nova Era Labs - AI Lab Training ROI\n\nWithout program: ₹${roi.avg_salary_without_program} LPA average\nWith program: ₹${roi.avg_salary_with_program} LPA average\nSalary uplift: +₹${roi.avg_salary_with_program - roi.avg_salary_without_program} LPA\n\n✅ ${roi.placement_rate_percent}% Placement Rate | ⏱ ${roi.program_duration_months} Months | 🎓 Scholarship Available\n\nRegister free: ${kit.registration_url}`}
                    </div>
                    <div style={{ marginTop: 8 }}>
                      <CopyButton text={`🚀 Nova Era Labs - AI Lab Training ROI\n\nWithout program: ₹${roi.avg_salary_without_program} LPA average\nWith program: ₹${roi.avg_salary_with_program} LPA average\nSalary uplift: +₹${roi.avg_salary_with_program - roi.avg_salary_without_program} LPA\n\n✅ ${roi.placement_rate_percent}% Placement Rate | ⏱ ${roi.program_duration_months} Months | 🎓 Scholarship Available\n\nRegister free: ${kit.registration_url}`} label="Copy ROI Summary" />
                    </div>
                  </div>
                </div>
              )}

              {/* Loom Script Tab */}
              {activeTab === 'loom' && (
                <div>
                  <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
                    Record a short Loom video using this script to share with students. Personalize [SHOW SCREEN] sections with actual screenshots:
                  </p>
                  <div style={{ background: '#fef9c3', border: '1px solid #fde68a', borderRadius: 10, padding: '14px 16px', whiteSpace: 'pre-wrap', fontSize: 13, color: '#1e293b', lineHeight: 1.7, fontFamily: 'monospace' }}>
                    {kit.loom_script}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                    <CopyButton text={kit.loom_script} label="Copy Script" />
                  </div>
                  <div style={{ marginTop: 16, padding: '12px 14px', background: '#f8fafc', borderRadius: 10 }}>
                    <p style={{ fontSize: 12, fontWeight: 700, color: '#64748b', margin: '0 0 6px' }}>📹 RECORDING TIPS</p>
                    <ul style={{ margin: 0, padding: '0 0 0 16px', fontSize: 12, color: '#64748b', lineHeight: 1.8 }}>
                      <li>Keep it under 3 minutes for best engagement</li>
                      <li>Show the actual GPU lab or demo screenshots</li>
                      <li>End with your registration link clearly visible</li>
                      <li>Upload to Loom and share the link via WhatsApp</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Failed to load outreach kit.</div>
        )}
      </div>
    </div>
  );
}
